<template>
  <div class="feedback">
    <img src="./assets/bg_feedback.png" class="img" alt="" @click="show"/>
    <van-overlay :show="isShow" @click.stop="isShow=false" z-index="999">
      <div class="wrapper">
        <div>
          <div class="close">
            <img src="../Dialog/img/dialog-close.png" alt="">
          </div>
          <div class="dialog" @click.stop>
            <div class="title">尊敬的会员，对于我们的活动你有什么好建议吗？请告诉我们</div>
            <div class="input">
              <textarea id="context" class="context" maxlength="200" placeholder="请输入您的宝贵建议" @input="inputEvent"/>
              <div class="tip">{{content.length}}/200</div>
            </div>
            <div class="btn" @click.stop="clickDialog">提交建议</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>

  import {Overlay, Toast} from 'vant'
  import Vue from 'vue';
  import service from "../../../service";
  import fectx from "helper/fectx";


  Vue.use(Overlay).use(Toast)
  export default {
    data() {
      return {
        isShow: false,
        content: ''
      }
    },
    created() {
    },
    methods: {
      show() {
        let that = this
        if (service.isLogin()) {
          that.isShow = true
        } else {
          that.$parent.handleLogin()
        }
      },
      inputEvent() {
        this.content = document.getElementById('context').value
      },
      async clickDialog() {
        let that = this
        if (!that.content.length) {
          Toast('亲，您还未填写内容哦，请填写后提交')
        } else {
          let params = {
            "acturl": window.location.href,
            "actname": document.title,
            "content": that.content
          }
          Toast.loading({message: '加载中...', duration: 0})
          let resp;
          try {
            resp = await fectx.put('/Act/MemberSuggestion/Add', params);
          } catch (_error) {
            // ingore
            Toast.clear()
          }
          Toast.clear()
          that.isShow = false
          const data = resp.data;
          // eslint-disable-next-line eqeqeq
          Toast(data.InnerData)
          if (data.ResultCode == 200) {
            document.getElementById('context').value = ''
            that.content = ''
          }else {
            return;
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "./styles/base";

  .feedback {

    .img {
      display: block;
      width: 100%;
    }

    .dialog {
      width: px2rem(280);
      background: #FFFFFF;
      box-sizing: border-box;
      padding: px2rem(25) px2rem(15);

      .title {
        color: #333333;
        font-size: px2rem(15);
        line-height: px2rem(22);
      }

      .input {
        margin-top: px2rem(12);
        border: px2rem(1) solid #EFD5BF;
        height: px2rem(178);
        display: flex;
        flex-direction: column;
        padding: px2rem(12);
        box-sizing: border-box;

        .context {
          display: block;
          flex: 1;
          color: #B9B9B9;
          font-size: px2rem(13);
          border: 0;
          resize: none;
          overflow: hidden;
        }

        .tip {
          margin-top: px2rem(12);
          color: #DABD97;
          font-size: px2rem(11);
          text-align: right;
        }

      }

      .btn {
        margin-top: px2rem(22);
        height: px2rem(36);
        background: #DABD97;
        color: #FFFFFF;
        font-size: px2rem(14);
        text-align: center;
        line-height: px2rem(36);
      }

    }
  }
</style>
